import React, { Suspense } from 'react';
import { withTranslation } from 'react-i18next';

export default (...withTranslationsArgs) =>
  Component => {
    const ComponentWithTranslation = withTranslation(...withTranslationsArgs)(
      Component
    );
    return props => (
      <Suspense fallback={<div />}>
        <ComponentWithTranslation {...props} />
      </Suspense>
    );
  };
